import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="not-found-illustration">
            <img 
              src="/images/404/404.jpg" 
              alt="404 Not Found" 
              className="not-found-image"
            />
          </div>

          <div className="not-found-actions">
            <button 
              className="btn-go-home"
              onClick={() => navigate('/')}
            >
              GO TO HOME
            </button>
            <button 
              className="btn-go-back"
              onClick={() => navigate(-1)}
            >
              GO BACK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;

